module.exports = __webpack_public_path__ + "static/img/3.4a4f405.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fu_shenfree/3.png
// module id = 98cl
// module chunks = 0